<div class="component-wrapper"  [class.loading]="actionLoading" >
<div nz-row [nzGutter]="[48, 24]">

  <div nz-col nzSpan="24" class="invoiceStatus" *ngIf="invoice" [class]="invoice.status.toLowerCase()">
    <div class="invoiceStatusTitle">
      [ {{ invoice.status | invoiceStatusName }} ]
    </div>
    <div class="reason" *ngIf="invoice.statusReason && isAdmin">{{ invoice.statusReason }}</div>
    <div class="seeInvoice" *ngIf="invoice.pennylaneFileUrl"><a [href]="invoice.pennylaneFileUrl" target="_blank">Voir la facture au format PDF</a></div>

    <div nz-col nzSpan="24" *ngIf="invoice && !isAdmin && isOrderNumberEditable()">
      Merci de bien vouloir saisir votre numéro de commande afin de valider la facture :
<div class="editOrderNumberCustomer">
  <label>Numéro de commande : </label>
  <input [(ngModel)]="orderNumberValue"  nz-input  placeholder="12345678" nzSize="large" maxlength="64" />
  <button [disabled]="isUpdating" nz-button nzType="primary"  (click)="saveOrderNumberForCustomer($event)"   nzSize="large"><span nz-icon nzType="sync" nzSpin *ngIf="isUpdating"></span> Modifier</button>
</div>

    </div>
  </div>

</div>

<div nz-row [nzGutter]="[48, 24]">

  <div nz-col nzSpan="10" nzOffset="14" *ngIf="invoice">
    <div>Le {{ invoice.updatedDate  | dfnsFormat:('dd/MM/yy') }}</div>
    <div class="mt-16"><strong>{{ invoice.companyName }}</strong></div>
    <div [innerHTML]="invoice.address.trim() | nl2br"></div>
    <div>{{ invoice.postalCode }}</div>
    <div>{{ invoice.city }}</div>
  </div>
</div>

<div nz-row [nzGutter]="[48, 0]">

  <div nz-col nzSpan="24">
    <span nz-typography>Référence de la facture : <strong>{{ invoice?.reference | nullCoal }}</strong></span>
  </div>
  <div nz-col nzSpan="24" *ngIf="invoice && (isAdmin || invoice?.status !== StatusInvoice.customerValidationRequired) ">
    <span nz-typography *ngIf="!(invoice?.status === StatusInvoice.invoiced || invoice?.status === StatusInvoice.paid) || invoice?.orderReference">Numéro de commande :
      <span *ngIf="!isOrderNumberEditable() "><strong>{{ invoice?.orderReference ? invoice?.orderReference : 'Aucun' }}</strong></span>

      <span *ngIf="isOrderNumberEditable() && !isOrderNumberEditing && isAdmin" (click)="editOrderNumber()" class="orderNumberEditableText"><strong>{{ invoice?.orderReference ? invoice?.orderReference : 'Aucun' }}</strong> &nbsp;<span nz-icon nzType="edit" nzTheme="outline" ></span></span>


      <span *ngIf="isOrderNumberEditable() && isOrderNumberEditing" laveoClickOutside (laveoClickOutside)="cancelEditing()" class="editOrderNumber">
        <input [(ngModel)]="orderNumberValue"  nz-input  placeholder="12345678" nzSize="large" maxlength="64" />
        <button [disabled]="isUpdating" nz-button nzType="primary"  (click)="saveOrderNumber($event)"   nzSize="large"><span nz-icon nzType="sync" nzSpin *ngIf="isUpdating"></span> Modifier</button>
      </span>
    </span>

  </div>



</div>
<div nz-row [nzGutter]="[48, 0]">

  <div nz-col nzSpan="24" class="mt-24">


    <nz-table [nzData]="['']" [nzFrontPagination]="false">
      <thead>
      <tr>
        <th nzColumnKey="articleReference">Référence</th>
        <th nzColumnKey="articleLabel">Libellé</th>
        <th class="centered" nzColumnKey="priceUnitWithoutVat">Prix unitaire HT</th>
        <th class="centered" nzColumnKey="quantity">Quantité</th>
        <th class="centered" nzColumnKey="priceTotalWithoutVat">Prix total HT</th>
        <th class="centered" nzColumnKey="priceTotal" >Prix total TTC</th>
        <th nzColumnKey="actions" *ngIf="isAdmin"></th>
      </tr>
      </thead>
      <tbody>

      <ng-container *ngFor="let section of invoice?.invoiceRequestSection">
        <tr>
          <td colspan="7" class="sectionHeader">{{ section.name }}</td>
        </tr>
        <ng-container *ngFor="let detail of section?.invoiceRequestDetail">
          <tr [class]="detail.needValidation? 'detail-warning':''">

            <td>{{ detail.articleReference }}</td>
            <td>
              <div><strong>{{ detail.additionalDescription }}</strong></div>
              <div>{{ detail.articleLabel }}</div>
            </td>
            <td class="centered">{{ detail.priceUnitWithoutVat | currency: 'EUR' }}</td>
            <td class="centered">{{ detail.quantity }}</td>
            <td class="centered">{{ detail.priceTotalWithoutVat | currency: 'EUR' }}</td>
            <td  class="centered" >{{ detail.priceTotal  | currency: 'EUR' }}</td>

            <td class="actions" *ngIf="isAdmin">

              <div *ngIf="canDoActionOnInvoice(invoice)">

                <button nz-tooltip nzTooltipTitle="Supprimer la ligne" nz-button nzType="primary" class="ml-8"
                        (click)="removeInvoiceDetail(detail)" *ngIf="userCanDelete">
                  <i nz-icon nzType="delete"></i>
                </button>

              </div>
            </td>

          </tr>
        </ng-container>

      </ng-container>
      <tr class="last-line">

        <td colspan="4" class="total-title">Total</td>

        <td>{{ invoice?.totalAmountWithoutVat | currency: 'EUR' }}</td>
        <td>{{ invoice?.totalAmount  | currency: 'EUR' }}</td>

        <td class="actions">

        </td>

      </tr>
      </tbody>
    </nz-table>
  </div>

  <div nz-col nzSpan="24" class="mt-16 action-bottom"
       *ngIf="invoice?.status !== StatusInvoice.invoiced && invoice?.status !== StatusInvoice.paid && isAdmin">
    <button nz-button nzType="primary" nzSize="large" (click)="validate()">{{ getValidationText() }}</button>
  </div>

</div>


  <div *ngIf="actionLoading" class="overlay">
    <div class="spinner"></div>
    <div class="loading-text">Veuillez patienter...</div>


  </div>
</div>
